<template>
	<div class="container">

		<div class="loading" v-if="isDetail">
			<van-loading size="40px" type="spinner" color="#39CCCD" vertical>
				<div class="loading-text">
					<div>页面正在加载</div>
					<div>请稍候</div>
				</div>
			</van-loading>
		</div>

		<!-- 课程详情展示 -->
		<div class="content" v-html="detail.detail" v-show="!isDetail" @click="handleEnroll">
		</div>

		<div class="footer-fit" v-if="!isDetail && !detail.purchased">
			<!-- <div class="top">仅剩6个名额，请在
				<div class="top-size">{{ minutes }}</div>
				<div style="padding: 0 5px;">:</div>
				<div class="top-size">{{ seconds }}</div>
				<div style="padding: 0 5px;">:</div>
				<div class="top-size wt">{{ millisecond }}</div>
				内领取
			</div> -->
			<div class="center">
				<div class="anniu" @click="handleEnroll">限时0元领取</div>
			</div>
		</div>

		<div class="footer-fit" v-if="!isDetail && detail.purchased">
			<div class="bottom2" @click="to_link()">已领取，去加老师上课</div>
		</div>

		<!-- 手机验证码 -->
		<div v-if="show">
			<div class="popup_mengceng" @click="show = false"></div>
			<div class="popup-two">
				<div class="top">
					<div style="display: flex;align-items: center;">
						<van-icon name="checked" color="#00ff45" size="18px" />
						<div style="margin-left: 10px;">已通过安全认证，可放心填写</div>
					</div>
					<van-icon name="cross" color="#dcdee0" size="18px" class="icon" @click="show = false" />
				</div>
				<div class="center">
					<div><input clearable v-model="form.phone" class="phone" placeholder="为确保正常上课，请输入手机号" type="tel"
							maxlength="11" :rules="rules" @focus="onFocus"></div>
					<div style="position: relative;" v-show="form.phone.length == 11">
						<input clearable v-model="form.sms" type="tel" class="sms" placeholder="请输入验证码" maxlength="6"
							:rules="rules" @focus="onFocus">
						<div slot="button" class="code-text" @click="getCode">{{ msgs }}<span v-show="isSend">后重试</span>
						</div>
					</div>
				</div>
				<div class="bottom" @click="pay">立即领取</div>
			</div>
		</div>

		<!-- 弹幕 -->
		<!-- <div class="danmu" :class="isDanmu ? 'fade-out' : 'fade-in'" v-if="!isDetail">
			<img :src="danmus.img" style="width: 20px;height: 20px;border-radius: 50px;" />
			<div style="padding: 0 10px;">{{ danmus.name }}</div>
			<div>{{ danmus.time }} 领取了课程</div>
		</div> -->

		<DanmuView v-if="!isDetail" wenAn="领取了课程"></DanmuView>
	</div>
</template>

<script>
var that;
import DanmuView from '@/components/danmuView/danmuView.vue';
import { checkStr,clickThrottle } from '@/utils/validate'
import { Toast } from 'vant';
import wx from 'weixin-js-sdk'

export default {
	name: 'LoginIndex',
	components: {
		DanmuView
	},
	props: {},
	data() {
		return {
			id: '',
			tid: '',
			recordBg: require('@/assets/record_bg.png'),
			isDetail: true,
			form: {
				phone: '',
				sms: ''
			},
			detail: {
				price: 0,
				courseDetail: '',
				purchased: false
			},
			rules: [{
				required: true,
				message: '请输入手机号'
			}, {
				pattern: /^1\d{10}$/,
				message: '请输入正确的手机号'
			}],
			msgs: '获取验证码',
			token: '',
			show: false,
			isSend: false,
			orderId: '',
			status: '',
			minutes: '00',
			seconds: '00',
			millisecond: '0',
			countDownTime: 15 * 60 * 1000,
			intervalId: null,
			isDanmu: false,
			danmus: {
				img: require('@/assets/avatar2.jpg'),
				name: '陈*',
				time: '5秒前'
			},
			vxCode: '',
			clickTimer: 0, //防止重复点击
		}
	},
	computed: {},
	watch: {},
	created() {
		that = this
		that.id = this.$route.query.channel_id;
		that.tid = this.$route.query.tid || -1;
		that.token = localStorage.getItem('token') || '';

		// 设置倒计时间隔和初始更新
		that.clearTimer()
		that.countdownTime = new Date().getTime() + 5 * 60 * 1000 // 15分钟
		that.intervalId = setInterval(() => {
			that.updateCountdown(that.countdownTime)
		}, 200)

		that.getConfig();
		that.getChannelsInfo();

		// if(this.token != ''){
		// 	that.getOrderDetail();
		// }

		//有code去登录
		const queryObj = this.getQueryObj()
		if (queryObj['code']) {
			this.getVxCode()
		}
		// setInterval(() => {
		// 	that.getPhone()
		// }, 5000);
	},
	methods: {

		getConfig() {
			var that = this
			this.$http.post('/u/app/mp/config', {
				url: window.location.href
			}).then(res => {
				const result = res.data
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端
					appId: result.appId, // 必填，公众号的唯一标识
					timestamp: result.timestamp, // 必填，生成签名的时间戳
					nonceStr: result.nonceStr, // 必填，生成签名的随机串
					signature: result.signature, // 必填，签名
					jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
				})
				wx.ready(() => {
					console.log('配置成功-fail-<')
					that.getReady()
				})
				// 当配置不成功时执行
				wx.error(res => {
					// 输出错误信息
					console.log('-配置不成功-fail-<', res)
					if (res.errMsg && res.errMsg.includes('the permission value isoffline verifying')) {
						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端
							appId: result.appId, // 必填，公众号的唯一标识
							timestamp: result.timestamp, // 必填，生成签名的时间戳
							nonceStr: result.nonceStr, // 必填，生成签名的随机串
							signature: result.signature, // 必填，签名
							jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
						})
						wx.ready(() => {
							console.log('配置成功2-fail-<')
							that.getReady()
						})
					}
				})
			})
		},

		//拿到code先不登录，等用户输入手机号确认点击领取的时候再登录，这里只是获取授权信息配置
		getVxCode() {
			const queryObj = this.getQueryObj()
			this.$http.get('/u/app/mp/cacheCode', {
				code: queryObj['code']
			}).then(res => {
				console.log("getVxCode", res.data)
				that.vxCode = queryObj['code'];
				that.show = true; 
			})
		},

		getLogin() {
			//拿到code去登录
			that.token = localStorage.getItem('token') || '';
			if (that.token != '') {
				return
			}
			const queryObj = this.getQueryObj()
			this.$http.get('/u/app/login/mpLogin', {
				code: queryObj['code'],
				tid: that.tid,
				channelId: this.id
			}).then(res => {
				console.log("token", res.data)
				localStorage.setItem('token', res.data)

				that.$http.get('/app/channels/getOrder', {
					id: that.id,
				}).then(res => {
					if (!res.data) {//之前没有订单，跳转第二个页面
						that.show = true;
						return
					}

					// 状态(-1已取消0待付款1已付款)
					if (res.data.status === 1) {
						that.detail.purchased = true;
						that.getAgainCourse()
					}
				})

			}).catch(err => {
				//登录失效，清除token
				that.$toast('登录已失效,请退出再试')
				localStorage.removeItem('token')
				that.token = "";
			})
		},

		handleEnroll() {
			// 课程详情用户已购买直接跳转二维码页面
			if (this.detail.purchased) {
				this.to_link()
				return
			}

			if (that.vxCode == '') {
				console.log('获取vx授权code')
				window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd06acaafd7167053&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`)
			} else {
				that.show = true;
			}

			// that.token = localStorage.getItem('token') || '';
			// if (that.token == '') {
			// 	console.log('获取vx授权code')
			// 	window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd06acaafd7167053&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`)
			// } else {
			// 	that.show = true;
			// }
		},

		getPhone() {
			this.isDanmu = true;
			setTimeout(() => {
				this.isDanmu = false;
				var num = Math.floor(Math.random() * 17);
				var list = [{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845065000751828992.jpg", name: "小笑玉" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845059170669268992.jpg", name: "李冬丽" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845059032240459776.jpg", name: "时光静好" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845057205503627264.jpg", name: "年年有余" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845045951246471168.jpg", name: "一如既往" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845045037685116928.jpg", name: "难得糊涂" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845044890985140224.jpg", name: "刘笑敏" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845010975356456960.jpg", name: "晨光曦影" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845002111324098560.jpg", name: "春暖花开" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845000414124150784.jpg", name: "风雨过林" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844984893706178560.jpg", name: "谢长征" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844984502872543232.jpg", name: "淡然接受" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844311874545487872.jpg", name: "旅途的人" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844288726492090368.jpg", name: "知足常乐" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844280029464334336.jpg", name: "谓我" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844238354637492224.png", name: "陈笑笑" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844233814890614784.jpg", name: "丽笑丽" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844233663568515072.jpg", name: "凌智科练" }]
				this.danmus.img = list[num].avatar;
				this.danmus.name = list[num].name;
				this.danmus.name = this.danmus.name.charAt(0) + '*'.repeat(this.danmus.name.length - 1) + this.danmus.name.charAt(this.danmus.name.length - 1);
				this.danmus.time = (Math.floor(Math.random() * 60) + 1) + '秒前';
			}, 1000)
		},

		//获取验证码
		getCode() {
			if (!this.form.phone) {
				this.$toast('请输入手机号')
				return
			}
			if (!checkStr(this.form.phone, 'mobile')) {
				this.$toast('请输入正确的手机号')
				return
			}
			if (this.isSend) return

			this.$http.post('/u/ali/sms', {
				phone: this.form.phone
			}).then(res => {
				this.$toast('验证码已发送')
				let count = 60
				this.isSend = true
				this.msgs = count + 's'
				this.timer = setInterval(() => {
					if (count === 1) {
						this.isSend = false
						this.msgs = '获取验证码'
						clearInterval(this.timer)
						return
					}
					count--
					this.msgs = count + 's'
				}, 1000)
			})
		},

		pay() {
			var that = this;
			if (!that.form.phone) {
				that.$toast('请输入手机号')
				return
			}
			if (!checkStr(that.form.phone, 'mobile')) {
				that.$toast('请输入正确手机号')
				return
			}
			if (!that.form.sms) {
				that.$toast('请输入验证码')
				return
			}

			var timeObj = clickThrottle(that.clickTimer,true); //防止多次点击
			if (!timeObj.isTime) {
				console.log('你点的太快了，请稍候再试')
				return
			}
			that.clickTimer = timeObj.timer;

			//判断验证码、登录、下单一次性接口
			this.$http.post('/u/app/login/mpSmsCodeLogin', {
				phone: that.form.phone,
				smsCode: that.form.sms,
				code: that.vxCode,
				tid: that.tid,
				channelId: that.id
			}).then(res => {
				localStorage.setItem('token', res.data)
				that.show = false;
				that.addOrder()
			}).catch(err => {
				that.$toast(err.msg)
			})

			//判断验证码是否正确后再下单 
			// this.$http.post('/app/users/verifyPhone', {
			// 	phone: that.form.phone,
			// 	smsCode: that.form.sms
			// }).then(res => {
			// 	that.show = false;
			// 	that.getOrderDetail(true)
			// }).catch(err => {
			// 	that.$toast(err.msg)
			// })
		},

		//下单
		addOrder() {
			var that = this;
			that.$http.post('/app/orders/add', {
				...that.detail,
				orderSource: '公众号',
				courseId: that.detail.courseId,
				phone: that.form.phone
				// grade: that.form.grade
			}).then(res => {
				that.orderId = res.data;
				if (that.detail.price === 0) {
					that.$toast('领取成功')
					setTimeout(() => {
						that.to_link()
					}, 500);
				}
			}).catch(err => {
				that.$toast(err.msg)
				if(err.code == 10001){
					this.detail.purchased = true;
					this.getAgainCourse()
				}
			})
		},

		//isPay 是否手动点支付
		getOrderDetail(isPay = false) {
			that = this
			that.$http.get('/app/channels/getOrder', {
				id: that.id,
			}).then(res => {
				if (res.code == 401) {
					//token过期提示重新登录
					console.log('token过期就返回第一个页面')
					that.$toast('登录已失效，请重新再试')
					localStorage.removeItem('token')
					that.token = "";
					return
				}

				if (!res.data) {//之前没有订单，去生成订单
					if (isPay) {
						that.addOrder()
					}
					return
				}
				that.orderId = res.data.id
				that.status = res.data.status

				// 状态(-1已取消0待付款1已付款)
				if (res.data.status === 1) {
					if (isPay) {
						that.$toast('领取成功')
						setTimeout(() => {
							that.to_link()
						}, 500);
					}
				}
			})
		},

		// 获取课程详情
		getDetail(id) {
			var that = this;
			this.$http.get('/u/app/courses/detail', {
				id: id
			}).then(res => {
				console.log("数据" + res)
				that.detail.purchased = res.data.purchased;
				if(res.data.purchased){
					that.getAgainCourse()
				}
			})
		},
		
		//已购买训练营，如果训练营过期重新获取绑定最新训练营课程
		getAgainCourse() {
			this.$http.get('/app/users/updateTeacherByChannelId', {
				channelId: this.id
			}).then(res => {
				console.log('重新获取课程', res.data)
			})
		},

		getChannelsInfo() {
			var that = this;
			this.$http.get('/app/channels/getInfo', {
				id: that.id
			}).then(res => {
				console.log("数据" + res)
				that.detail = res.data
				that.detail.detail = res.data.detail.replaceAll("<img ", "<img onclick='return false' ");
				document.title = res.data.title;
				that.getDetail(res.data.courseId)

				setTimeout(() => {
					that.isDetail = false
				}, 500)
			}).catch(err => {
				setTimeout(() => {
					that.isDetail = false
					Toast('网络出现问题，请刷新重试!');
				}, 3000);
			})
		},

		to_link() {
			this.$router.push({
				path: '/vxPublic/successTwo',
				query: { orderId: this.orderId }
			})
		},

		clearTimer() {
			clearInterval(this.intervalId)
			this.intervalId = null
		},

		updateCountdown(endTime) {
			const now = new Date().getTime()
			const distance = endTime - now

			if (distance < 0) {
				this.minutes = '00'
				this.seconds = '00'
				this.millisecond = '0'
				this.clearTimer()
				return
			}

			this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)) + ''
			this.seconds = Math.floor((distance % (1000 * 60)) / 1000) + ''
			this.millisecond = parseInt(Math.floor((distance % (1000 * 60)) % 1000) / 100) + ''
			this.minutes = this.minutes.length < 2 ? '0' + this.minutes : this.minutes
			this.seconds = this.seconds.length < 2 ? '0' + this.seconds : this.seconds
		},

		getReady() {
			var that = this;
			let shareUrl = window.location.href
			if (shareUrl.indexOf('code=') > 0) {
				shareUrl = shareUrl.match(/(\S*)&code=/)[1]
			}
			console.log('分享的链接', shareUrl)
			console.log('分享的内容', that.detail.courseName)
			wx.updateAppMessageShareData({
				title: `限时0元领取>> 99元写字课`, // 分享标题
				desc: '5天写出漂亮字，每天练习15分钟，有1对1书法老师点评，让练字变简单！', // 分享描述
				link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				imgUrl: 'https://mp.51xxc.com/courses/static/conrses_icon.png', // 分享图标
				success: function (res) {
					// 设置成功
					// wx.showMenuItems({
					//   menuList: ['menuItem:share:appMessage'] // 要显示的菜单项，所有menu项见附录3
					// })
					console.log('-22-分享success-<')
				},
				fail: e => {
					console.log('-22-分享fail-<', e)
				}
			})
			wx.updateTimelineShareData({
				title: `限时0元领取>> 99元写字课`, // 分享标题
				desc: '5天写出漂亮字，每天练习15分钟，有1对1书法老师点评，让练字变简单！', // 分享描述
				link: shareUrl,
				imgUrl: 'https://mp.51xxc.com/courses/static/conrses_icon.png', // 分享图标
				success: function (res) {
					// 设置成功
					// wx.showMenuItems({
					//   menuList: ['menuItem:share:timeline'] // 要显示的菜单项，所有menu项见附录3
					// })
					console.log('-33-分享success-<')
				},
				fail: e => {
					console.log('-33-分享fail-<', e)
				}
			})
		},

		// 获取地址栏的参数
		getQueryObj() {
			var query = window.location.search
			var queryObj = {}
			var arr = query.slice(1, query.length).split('&')
			arr.forEach(function (val) {
				var arr1 = val.split('=')
				queryObj[arr1[0]] = arr1[1]
			})
			return queryObj
		},

		onFocus(e) {
			setTimeout(() => {
				window.scrollTo({
					top: document.body.scrollHeight,
					behavior: 'smooth'
				});
			}, 400);
		}

	}
}
</script>

<style scoped lang="less">
.popup_mengceng {
	z-index: 2001;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, .7);
}



.popup-two {
	background-color: #fff;
	bottom: 0;
	left: 0;
	width: 100%;
	position: fixed;
	max-height: 100%;
	overflow-y: auto;
	background: #ffffff;
	border-radius: 50px 50px 0 0;
	z-index: 2002 !important;

	.top {
		display: flex;
		justify-content: center;
		font-size: 28px;
		color: #666;
		position: relative;
		padding: 40px 0;

		.icon {
			position: absolute;
			top: 40px;
			right: 20px;
		}
	}

	.center {
		margin: 20px 20px 60px 20px;

		.phone {
			border-radius: 20px;
			background-color: #f4f4f4;
			// padding: 30px 20px !important;
			font-size: 30px;
			width: 92%;
			padding: 30px 27px !important;
			border: none !important;
		}

		.code-text {
			color: #ff6933;
			position: absolute;
			top: 24px;
			right: 27px;
			bottom: 0;
			display: flex;
			align-items: center;
			font-size: 30px;
		}

		.sms {
			// position: relative;
			margin-top: 20px;
			background: #f5f5f5;
			border-radius: 20px;
			font-size: 30px;
			width: 92%;
			padding: 30px 27px !important;
			border: none !important;
		}
	}

	.bottom {
		margin: 20px 20px 40px 20px;
		background-color: #ff6933;
		border-radius: 60px;
		text-align: center;
		color: #fff;
		font-size: 40px;
		font-weight: bold;
		padding: 30px;
	}
}

.content img {
	pointer-events: none;
	cursor: default;
}

.loading {
	margin: 40vh auto;
	text-align: center;

	.loading-text {
		color: #39CCCD;
		font-weight: bold;
	}
}

.container {
	color: #333;
	font-size: 28px;
	// height: 100vh !important;
	height: 100%;
	display: flex;
	flex-direction: column;

	.content {
		flex: 1;
		position: relative;
		// padding-bottom: 140px;
		// height: 100vh !important; 
		overflow-y: auto;

		::v-deep img {
			display: block;
			width: 100% !important;
		}
	}
}

.header-bg {
	width: 100vw;
}

.footer-fit {
	flex-shrink: 0;
	width: 100%;
	bottom: 0;
	z-index: 2;
	background-color: #fff;

	.top {
		background-color: #ffeee7;
		font-size: 26px;
		color: #ff6616;
		text-align: center;
		padding: 12px;
		display: flex;
		align-items: center;
		justify-content: center;

		.top-size {
			background: #ff6a33;
			border-radius: 4px;
			color: #ffffff;
			padding: 0 4px;
			width: 40px;
		}

		.wt {
			width: 30px !important;
		}
	}

	.center {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 20px;

		.anniu {
			font-weight: 600;
			background-color: #ff6933;
			color: #fff;
			width: 100%;
			padding: 18px;
			border-radius: 50px;
			text-align: center;
			font-size: 50px;
			font-family: sans-serif;
			margin: 10px 20px 25px 20px;
			animation: styles-module_pulse .7s linear infinite;
		}

		@keyframes styles-module_pulse {
			0% {
				transform: scale(.95)
			}

			50% {
				transform: scale(1.02)
			}

			to {
				transform: scale(.95)
			}
		}
	}

	.bottom {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
		padding-bottom: 40px;
		font-weight: 500;

		.pl {
			padding-left: 4px;
		}

		.size {
			color: #ff6933;
		}
	}

	.bottom2 {
		color: #fff;
		margin: 20px 40px 40px 40px;
		background: #ff6933;
		border-radius: 60px;
		text-align: center;
		font-size: 36px;
		font-weight: bold;
		height: 96px;
		line-height: 96px;
	}
}



.danmu {
	display: flex;
	align-items: center;
	position: absolute;
	bottom: 15vh;
	right: 20px;
	padding: 10px 20px;
	background: #00000075;
	color: #fff;
	font-size: 28px;
	border-radius: 50px;
	width: 60%;
	font-family: sans-serif;
}

.fade-in {
	animation: slide-up-fade-in 1s forwards;
}

@keyframes slide-up-fade-in {
	0% {
		transform: translateY(10px);
		opacity: 0;
	}

	100% {
		transform: translateY(0);
		opacity: 1;
	}
}

.fade-out {
	animation: slide-up-fade-out 1s forwards;
}

@keyframes slide-up-fade-out {
	0% {
		transform: translateY(0);
		opacity: 1;
	}

	100% {
		transform: translateY(-30px);
		opacity: 0;
	}
}
</style>